import { ChevronRight, ChevronLeft, Pencil } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ui/card";
import { StepProps } from "../types";
import TagSelector from "./TagSelector";

interface StepTwoProps extends StepProps {
  roleTitle: string;
  onRoleTitleChange: (title: string) => void;
  jobDescription: string;
  selectedTags: string[];
  onTagsChange: (tags: string[]) => void;
  onEditDescription: () => void;
  onBack?: () => void;
  onForward?: () => void;
  canGoBack?: boolean;
  canGoForward?: boolean;
}

export const StepTwo = ({
  onNext,
  roleTitle,
  onRoleTitleChange,
  jobDescription,
  selectedTags,
  onTagsChange,
  onEditDescription,
  onBack,
  canGoBack = true,
  canGoForward = true,
}: StepTwoProps) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <div className="h-5 w-5 rounded-full bg-primary flex items-center justify-center text-white text-sm font-medium">
          2
        </div>
        <h2 className="text-xl font-semibold mb-0">Förfina din sökning</h2>
      </div>

      <div className="space-y-2">
        <Label htmlFor="role-title">Jobbtitel</Label>
        <Input
          id="role-title"
          value={roleTitle}
          onChange={(e) => onRoleTitleChange(e.target.value)}
          placeholder="T.ex. Säljare, Marknadsförare, etc."
        />
      </div>

      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <Label>Jobbeskrivning</Label>
          <Button
            variant="ghost"
            size="sm"
            onClick={onEditDescription}
            className="flex items-center gap-1">
            <Pencil className="h-4 w-4" />
            Redigera
          </Button>
        </div>
        <div className="space-y-4">
          <div>
            <Label className="text-sm text-muted-foreground mb-2 block">
              Jobbeskrivning (genererad av AI)
            </Label>
            <Card className="p-4 bg-muted/50">
              <div
                className="text-sm prose prose-sm max-w-none"
                dangerouslySetInnerHTML={{ __html: jobDescription }}
              />
            </Card>
          </div>
        </div>
      </div>

      <div className="space-y-2">
        <Label>Relevanta taggar</Label>
        <TagSelector selectedTags={selectedTags} onTagsChange={onTagsChange} />
      </div>

      <div className="flex justify-between items-center pt-4 border-t">
        <Button
          variant="outline"
          onClick={onBack}
          disabled={!canGoBack}
          className="flex items-center gap-2">
          <ChevronLeft className="h-4 w-4" />
          Föregående
        </Button>

        <div className="flex gap-2">
          <Button
            onClick={onNext}
            disabled={
              !roleTitle.trim() || selectedTags.length === 0 || !canGoForward
            }
            className="flex items-center gap-2">
            Nästa steg
            <ChevronRight className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StepTwo;
